import { TimeRangesConfig } from "@bryntum/schedulerpro";

export const timeRangesFeature = {
    showCurrentTimeLine: true,
    showHeaderElements: false,
    enableResizing: false,
    currentDateFormat: "MMM DD, YYYY",
    currentTimeLineUpdateInterval: 1000 * 60,
} satisfies TimeRanges | Partial<TimeRangesConfig>;
